import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/logo.svg";
import Menu from "../../assets/images/menu.svg";
import { ReactSVG } from "react-svg";
import FormControl from "@material-ui/core/FormControl";
import { withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { mapStateToProps, mapDispatchToProps } from "../../actions/addresses";
import { useStylesNavBar } from "./style";
import { useDarkmodeContext } from "react-use-dark-mode";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { useComponentVisible } from "./../transaction/sharedComponent/outSideClick";
import ConfirmModal from "../AlertModal/confirmModal";
import { Event, WalletMA } from "boa-sdk-ts";
import { loadWalletData, saveWalletData } from "../../utils/WalletUtils";
import { changeAccount, changeBalance } from "../../actions/walletAction";
import WalletListBox from "./presenter/walletBox";
import ModeStatus from "./presenter/modeStatus";
import ThemeOption from "./presenter/themeOption";
import MobileMenu from "./presenter/mobileMenu";
import BalanceBox from "./balanceBox";
import NetworkOption from "./networkOption";
import { changeEndpoint } from "../../actions/networkAction";

const NavBar = (props) => {
  // These are all states of the current component
  const classes = useStylesNavBar();
  const dispatch = useDispatch();
  const { t, totalAccounts, selectedAccount, endpoint } = props;

  const [totalSelfPayment, SetTotalSelfPayment] = useState({
    total: 0,
    spendable: 0,
  });
  const [totalPayment, SetTotalPayment] = useState({ total: 0, spendable: 0 });

  const [WalletNames, setWalletNames] = useState([]);
  const [currentAddress, setCurrentAddress] = useState("");

  const { selectedAccountName } = useSelector((state) => state.wallet);

  const [activeTab, setActiveTab] = useState("");

  const [addressDropdown, setAddressDropdown] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const { ref, isComponentVisible } = useComponentVisible(true);

  const { accounts, watcher } = WalletMA.instance();
  const [accessMode, setAccessMode] = useState({
    mode: 0,
    sudoLength: 0,
  });

  useEffect(() => {
    watcher.addEventListener(Event.NEW_BLOCK, newBlockEventHandler);
    initAccount().then(() => {
      paintAccountList();
      if (accounts.length > 0 && props.history.location.pathname === "/") {
        props.history.push("/overview");
      }
    });
  }, []);

  useEffect(() => {
    accounts.checkBalance();
  }, [endpoint]);

  useEffect(() => {
    if (totalAccounts) {
      SetTotalPayment({
        total: totalAccounts.balance.toString(),
        spendable: totalAccounts.spendable.toString(),
      });
    }
  }, [totalAccounts]);

  useEffect(() => {
    if (selectedAccount) {
      SetTotalSelfPayment({
        total: selectedAccount.balance.toString(),
        spendable: selectedAccount.spendable.toString(),
      });
    }
    modeStatusMethod();
  }, [selectedAccount]);

  const newBlockEventHandler = (type, height) => {
    if (type === Event.NEW_BLOCK) {
      console.log("NavBar:NewBlockEvent:" + height);
      props.SocketConnection(height);
    }
  };

  const initAccount = async () => {
    accounts.addEventListener(Event.CHANGE_BALANCE, accountEventHandler);
    accounts.addEventListener(Event.ADDED, accountEventHandler);
    accounts.addEventListener(Event.REMOVED, accountEventHandler);
    accounts.addEventListener(Event.CHANGE_SELECTED, accountEventHandler);
    accounts.addEventListener(Event.CHANGE, accountEventHandler);
    accounts.addEventListener(Event.CHANGE_SECRET_KEY, accountEventHandler);
    loadWalletData();
    await accounts.checkBalance();
    if (accounts.length > 0) {
      await accounts.selected_account.checkBalance();
      dispatch(changeAccount(accounts.selected_account));
    } else {
      props.history.push("/");
    }
  };

  const paintAccountList = () => {
    const accList = accounts.items;
    if (accList.length > 0) {
      let items = accList.map((m) => {
        return {
          name: m.name,
          address: m.address.toString(),
        };
      });
      setWalletNames(items);
    }
  };

  const accountEventHandler = (type, data) => {
    console.log("NavBar:Event." + type);
    switch (type) {
      case Event.CHANGE_BALANCE:
        dispatch(changeBalance(data, accounts.selected_account));
        break;
      case Event.ADDED:
        accounts.checkBalance();
        break;
      case Event.REMOVED:
        accounts.checkBalance();
        break;
      case Event.CHANGE_SELECTED:
        setCurrentAddress(
          accounts.selected_account
            ? accounts.selected_account.address.toString()
            : null
        );
        dispatch(changeAccount(accounts.selected_account));
        break;
      case Event.CHANGE:
        if (accounts.length > 0) {
          paintAccountList();
          modeStatusMethod();
        } else {
          props.history.push("/");
        }
        break;
      case Event.CHANGE_SECRET_KEY:
        if (accounts.length > 0) modeStatusMethod();
    }
  };

  // Method for endPoints change
  const handleChangeEndPoint = (e) => {
    dispatch(changeEndpoint(e.target.value));
  };
  // Method to redirect to selected page use during mobile view just.
  const RedirectToPage = (tab) => {
    setActiveTab(tab);
    props.history.push("/" + tab);
  };

  const modeStatusMethod = () => {
    if (accounts.selected_account) {
      setAccessMode({
        mode: accounts.selected_account.mode,
        sudoLength: accounts.sudo_length,
      });
    } else {
      setAccessMode({
        mode: 0,
        sudoLength: 0,
      });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (!isComponentVisible) {
        setAddressDropdown(false);
      }
    });
  }, [isComponentVisible]);

  const onAddressDropdownClick = () => {
    if (addressDropdown) {
      setAddressDropdown(false);
    } else {
      setAddressDropdown(true);
    }
  };

  const DeleteAddress = (name, status) => {
    accounts.remove(name);
    saveWalletData();
  };

  return (
    <>
      {props.history.location.pathname === "/" ||
      props.history.location.pathname === "/add-new-account" ? (
        <nav className="navbar navbar-expand-lg navbar-light bg-light customHeader">
          <div className="navbar-brand">
            <img alt="Logo" src={Logo} />
          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto" />
          </div>
        </nav>
      ) : (
        <nav className="navbar navbar-expand-lg navbar-light bg-light customHeader">
          <div
            className="navbar-brand"
            onClick={(e) => RedirectToPage("overview")}
          >
            <img alt="Logo" src={Logo} />
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <ReactSVG src={Menu} />
          </button>

          <div
            className="collapse navbar-collapse navBg"
            id="navbarSupportedContent"
          >
            {/* Menu list for Mobile Responsive View */}
            <MobileMenu activeTab={activeTab} redirectToPage={RedirectToPage} />

            <div className="HeaderCont">
              <div className="smDropdownbox">
                <div className="HomeSelect AccountInput">
                  {/* Dropdown to select and show Walet Address */}
                  <FormControl className={classes.formControl}>
                    <div ref={ref} className="custom_select_container">
                      <div
                        className="selected_account"
                        onClick={onAddressDropdownClick}
                      >
                        <p>{selectedAccountName}</p>
                        {addressDropdown ? (
                          <ArrowDropUpIcon className="caret" />
                        ) : (
                          <ArrowDropDownIcon className="caret" />
                        )}
                      </div>
                      {addressDropdown && (
                        <WalletListBox
                          walletList={WalletNames}
                          setAddressDropdown={setAddressDropdown}
                          DeleteAddress={DeleteAddress}
                          currentAddress={currentAddress}
                        />
                      )}
                    </div>
                  </FormControl>
                </div>
                <NetworkOption
                  endpoint={endpoint}
                  handleChangeEndPoint={handleChangeEndPoint}
                />
              </div>
              {/* Balances display parts */}
              <BalanceBox
                totalSelfPayment={totalSelfPayment}
                totalPayment={totalPayment}
              />
              {/* Account Mode options */}
              <ModeStatus accessMode={accessMode} />
              {/* Change theme color options */}
              <ThemeOption />
            </div>
          </div>
          {/* Delete record confirmation modal component */}
          <ConfirmModal
            open={openConfirmModal}
            actionEventConfirm={DeleteAddress}
            message={t("Are_you_sure_you_want_to_delete_this_account")}
          />
        </nav>
      )}
    </>
  );
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NavBar))
);
